import { CarriagePictogram } from '@/components/icons/CarriagePictogram';
import { PlacePictogram } from '@/components/icons/PlacePictogram';
import type { LegDTO } from '@/types/dto/agent';
import { cn } from '@/utils/cn';
import { Checkbox, Typography } from '@packages/webshop-design-system';
import type { FC } from 'react';

interface LegPassengerSelectionCardProps {
  passenger: {
    firstName: string;
    lastName: string;
    carriages?: string;
    seats?: string;
    age?: number;
  };
  ptMode?: LegDTO['ptMode'];
  isSecondLevelItem?: boolean;
  className?: string;
  placeIcon?: 'seat' | 'compartment' | 'bed';
  isChecked: boolean;
  onToggle: (checked: boolean) => void;
}

export const LegPassengerSelectionCard: FC<LegPassengerSelectionCardProps> = ({
  passenger,
  isSecondLevelItem = false,
  placeIcon = 'seat',
  className,
  isChecked,
  onToggle,
  ptMode,
}) => {
  return (
    <div
      className={cn(
        'cursor-pointer rounded-sm border border-neutral-light px-3 py-1.5 hover:border-primary-medium hover:bg-primary-pale',
        'focus-within:outline-none focus-within:ring-2 focus-within:ring-tint focus-within:ring-offset-2',
        className,
        {
          'border-primary bg-primary-light': isChecked,
        }
      )}
      onClick={() => onToggle(!isChecked)}
      data-state={isChecked ? 'checked' : 'unchecked'}
    >
      <div className="flex items-center gap-3">
        <div onClick={(e) => e.stopPropagation()}>
          <Checkbox isSelected={isChecked} onChange={onToggle} />
        </div>
        <div className="w-full">
          <div className="flex items-center justify-between gap-2">
            <Typography
              variant={isSecondLevelItem ? 'body2-bold' : 'body1-bold'}
            >
              {`${passenger.firstName} ${passenger.lastName}`}
            </Typography>
            <div className="flex items-center gap-1.5">
              {passenger.carriages && ptMode?.code !== 'BUS' && (
                <div className="flex items-center gap-1">
                  <CarriagePictogram
                    height={12}
                    width={12}
                    className="text-neutral"
                  />
                  <Typography variant="body2-bold" className="text-neutral">
                    {passenger.carriages}
                  </Typography>
                </div>
              )}
              {passenger.seats && (
                <div className="flex items-center gap-1">
                  <PlacePictogram
                    placeIcon={placeIcon}
                    height={12}
                    width={12}
                  />
                  <Typography variant="body2-bold" className="text-neutral">
                    {passenger.seats}
                  </Typography>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
